module.exports = __webpack_public_path__ + "img/cxTrends-3.33f264be.png";